import(/* webpackMode: "eager" */ "/app/frontend/src/app/dashboard/page.tsx");
